import {InnerFilters} from 'types';
import {ReturnAuditParams} from 'types/return-audit';

export const mapReturnAuditFilters = (filters: InnerFilters): ReturnAuditParams => {
    const text = (key: string) => {
        const item = filters[key];
        const value = item && typeof item === 'object' && 'value' in item ? item.value : item;
        return typeof value === 'string' ? value.trim() || undefined : undefined;
    };
    const [from, to] = (filters.eventTimestamp as [Date | null, Date | null]) || [];
    return {
        eventId: text('eventId'),
        userRole: text('userRole'),
        sortDesc: filters.sortDesc === undefined ? undefined : filters.sortDesc === 'true',
        userFullName: text('userFullName'),
        organizationName: text('organizationName'),
        organizationTin: text('organizationTin'),
        eventType: text('eventType'),
        documentId: text('documentId'),
        markingCode: text('markingCode'),
        disposalReason: text('disposalReason'),
        from: from
            ? new Date(from.getFullYear(), from.getMonth(), from.getDate()).toISOString()
            : undefined,
        to: to
            ? new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59, 999).toISOString()
            : undefined,
    };
};
